export const palette = {
  alternate: {
    main: '#F9F6FF',
    light: '#F9F8F8',
    dark: '#E5EAF4',
  },
  cardShadow: 'rgba(23, 70, 161, .11)',
  type: 'light',
  primary: {
    main: '#252A68',
    light: '#E9E9EF',
  },
  secondary: {
    main: '#799A62',
    contrastText: '#FFFFFF',
    light: '#D9EDF7',
  },
  text: {
    primary: '#22211F',
    secondary: '#4A5462',
    alternate: '#23B0E7',
    disabled: '#CCC',
    highlight: '#FFF',
    success: '#1CA179',
    border: '#E5EAF4',
  },
  divider: 'rgba(0, 0, 0, 0.12)',
  background: {
    main: '#FFFFFF',
    paper: '#FFF',
    default: '#FFF',
    header: '#7CA7AD',
    footer: '#1F3B61',
    level2: '#f7f8fb',
    level1: '#FFF',
    tableHead: '#252A68',
    tableSubhead: '#7CA7AD',
    tableBorder: '#7D808880',
    tableAlternate: '#FFFFFF',
    alternate: '#E5EAF4',
    success: '#DBEFDC',
    error: '#FFEAEA',
    primary: '#76E8C4',
    secondary: '#F8D859',
    light: '#EBF6FF',
    secondaryLight: 'rgba(238, 246, 250, 0.6)',
    primaryLight: '#D9EDF7',
    ribbon: '#bbe6fb',
  },
  surface: {
    grey: '#F4F4F4',
  },
  verticalBar: {
    used: '#76E8C4',
    unused: '#F6F6F6',
    unlimited: '#C0C0C0',
  },
};
